import $ from 'jquery';

var cssClassHover = 'js_hover';
var cssClassNavShown = 'js_nav-shown';
var $body = $('body');
var $mainNavItem = $('.main-nav-item');

// Migrated from workspace/Frontend/source/js/nm/ui/flyout.js
export default class Flyout {
  constructor() {
    this.isOpen = false;
    this.lastActiveItem = null;

    this.init();
  }

  init() {
    $mainNavItem.hover(function() {
      const $currentMainNavItem = $(this);

      if (!$currentMainNavItem.hasClass('flyout-disabled')) {
        $currentMainNavItem.data('flyoutVisible', true);
        if (self.isOpen) {
          _showFlyout.call(self, $currentMainNavItem);
        } else {
          setTimeout(function() {
            if ($currentMainNavItem.data('flyoutVisible') === true) {
              _showFlyout.call(self, $currentMainNavItem);
            }
          }, 250);
        }
      }
    }, function() {
      const $currentMainNavItem = $(this);

      if (!$currentMainNavItem.hasClass('flyout-disabled')) {
        $currentMainNavItem.data('flyoutVisible', false);
        setTimeout(function() {
          if ($currentMainNavItem.data('flyoutVisible') === false) {
            _closeFlyout.call(self, $currentMainNavItem);
          }
        }, 250);
      }
    });

    $(document).on('click', '.flyout-closer', function(event) {
      const $currentMainNavItem = $(event.target).parents('.main-nav-item');

      $currentMainNavItem.data('flyoutVisible', false);
      _closeFlyout.call(self, $currentMainNavItem);
      $body.removeClass('js_header-hovered');
    });

    // Touch devices
    $mainNavItem.on('touchstart', function() {
      const $currentMainNavItem = $(this);

      if (!$currentMainNavItem.hasClass('flyout-disabled')) {
        _showFlyout.call(self, $currentMainNavItem);
      }
    });

    $('.flyout-link').on('touchstart', function(event) {
      event.preventDefault();
    });

    $body.on('touchstart', _closeAllFlyouts.bind(this));

    initFlyoutCollapse();
  }
}

/**
 * @param {object} $currentMainNavItem jQuery node
 * @private
 */
function _showFlyout($currentMainNavItem) {
  this.isOpen = true;
  this.lastActiveItem = $currentMainNavItem[0];
  $mainNavItem.filter('.' + cssClassHover).removeClass(cssClassHover);
  $currentMainNavItem.addClass(cssClassHover);
  $body.addClass(cssClassNavShown);
}

/**
 * @param {object} $currentMainNavItem jQuery node
 * @private
 */
function _closeFlyout($currentMainNavItem) {
  if (this.lastActiveItem === $currentMainNavItem[0]) {
    this.isOpen = false;
    $currentMainNavItem.removeClass(cssClassHover);
    $body.removeClass(cssClassNavShown);
  }
}

/**
 * @param event
 * @private
 */
function _closeAllFlyouts(event) {
  if (!_isClickInsideFlyout(event)) {
    $mainNavItem.filter('.' + cssClassHover).removeClass('js_hover');
    $body.removeClass(cssClassNavShown);
  }
}

/**
 *
 * @param {object} event
 * @returns {boolean}
 * @private
 */
function _isClickInsideFlyout(event) {
  var isClickInsideFlyoutFlag = false;

  if (event !== undefined) {
    var element = event.target;
    while (element.parentNode && element !== document.documentElement) {
      if (element.classList.contains('flyout-content')) {
        isClickInsideFlyoutFlag = true;
        break;
      }
      element = element.parentNode;
    }
  }

  return isClickInsideFlyoutFlag;
}

function initFlyoutCollapse() {
  $(document).on('show.bs.collapse', '.flyout-collapse', function(event) {
    const $collapse = $(event.target);
    const $collapseToggle = $(`[data-target="#${$collapse.attr('id')}"]`);

    $collapseToggle.prev('.nav-link').addClass('js_collapse-active');
  });
  $(document).on('hide.bs.collapse', '.flyout-collapse', function(event) {
    const $collapse = $(event.target);
    const $collapseToggle = $(`[data-target="#${$collapse.attr('id')}"]`);

    $collapseToggle.prev('.nav-link').removeClass('js_collapse-active');
  });
}
